import '../css/Home.css'

import SkillCard from '../components/SkillCard'

import { AboutData } from '../data/AboutData'

import avatar from '../images/photo.png'

const Home = () => {
  return (
    <div className="content">
      <div className="introduction">
        <h1 className="slogan">Connecting Data to Business</h1>
        <div className="intro-content">
          <div className="about-me">
            <p className="paragraph">{AboutData.aboutMe}</p>
            <br />
            <ul className="business-problem">
              {AboutData.businessProblem.map((item) => {
                return <li>{item}</li>
              })}
            </ul>
          </div>
          <img className="avatar" src={[avatar]} alt="" />
        </div>
      </div>
      <div className="skills">
        <h1 className="skills-title">Skills</h1>
        <div className="skills-list">
          {AboutData.skillData.map((skill) => {
            return (
              <SkillCard
                img={skill.img}
                title={skill.title}
                content={skill.content}
              />
            )
          })}
        </div>
      </div>
      <div className="Websites">
        <h1 className="Websites-title">Websites</h1>
        <ul className="Websites-list">
          <li>
            My <a href="https://github.com/QinrenZhou">Github</a>
          </li>
        </ul>
      </div>
      <div className="contact">
        <h1 className="contact-title">Contact me&nbsp;&#128522;</h1>
        <ul className="contact-list">
          <li className="email">qz142@georgetown.edu</li>
          <li className="linkedin">linkedin.com/in/qinren-zhou</li>
          <li className="phone">571-778-1228</li>
        </ul>
      </div>
    </div>
  )
}

export default Home
